import React from "react";
import Text from "../atoms/Text";
import Button from "../atoms/Button";
import Icon from "../atoms/Icon";
import img404 from "../../assets/404.png";

export default function Error404() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
        <Icon name="error404" src={img404}/>
      <Text
        size="px40"
        weight="w600"
        color="gray9"
        extraStyles={{ marginBottom: "20px" }}
      >
        Oops! Page Not Found
      </Text>
      <Text
        size="px16"
        weight="w400"
        color="gray5"
        extraStyles={{ marginBottom: "24px" }}
      >
        The page you are looking for does not exist.
      </Text>
      <Button
        onClick={() => (window.location.href = "/")}
        variant="fill"
        size="large"
      >
        Go Back Home
      </Button>
    </div>
  );
}
